import { SUCCESS_MESSAGE, ERROR_MESSAGE } from "../../store/constants/general";
import { takeEvery } from "redux-saga/effects";
import { Notifications } from '../../../services';


function* displaySuccess(action) {
  yield Notifications.show({
    icon: "tick",
    message: action.message ? action.message : "Success!",
    intent: "success"
  });
}

function* displayError(action) {
  yield Notifications.show({
    icon: "warning-sign",
    message: action.message ? action.message : "Error!",
    intent: "danger"
  });
}

export default function* rootSaga() {
  yield takeEvery(SUCCESS_MESSAGE, displaySuccess);
  yield takeEvery(ERROR_MESSAGE, displayError);
}
